import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root =
  ({ collapsed }: { collapsed: boolean }) =>
  (theme: ExactTheme) => css`
    border-bottom-color: ${collapsed
      ? "transparent"
      : theme.colorsV2.grey[100]};
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding-bottom: ${collapsed ? 0 : "7px"};
  `;

export const content =
  ({ collapsed }: { collapsed: boolean }) =>
  (theme: ExactTheme) => css`
    padding-top: ${collapsed ? 0 : "5px"};
  `;

export const trigger =
  ({ collapsed }: { collapsed: boolean }) =>
  (theme: ExactTheme) => css`
    display: flex;
    justify-content: space-between;
    background-color: ${theme.colorsV2.grey[collapsed ? 25 : 50]};
    border-radius: ${theme.borderRadiusV2.primary};
    color: ${theme.colorsV2.grey[900]};
    font-weight: 600;
    padding: 7px 10px 7px 5px;
    min-height: 35px;
    align-items: center;
    border: none;
    width: 100%;
    :hover {
      cursor: pointer;
      background-color: ${theme.colorsV2.grey[collapsed ? 50 : 100]};
    }
    :active {
      cursor: pointer;
      background-color: ${theme.colorsV2.grey[collapsed ? 100 : 200]};
    }
  `;

export const arrowIconContainer = css`
  display: flex;
  align-items: center;
  padding-left: 10px;
`;

export const arrow = ({ collapsed }: { collapsed: boolean }) => css`
  transform-origin: center;
  transform: rotate(${collapsed ? 0 : 180}deg);
`;
